import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=f1c9d9ec&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1c9d9ec')) {
      api.createRecord('f1c9d9ec', component.options)
    } else {
      api.reload('f1c9d9ec', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=f1c9d9ec&", function () {
      api.rerender('f1c9d9ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z9Jp6aPrZG4M/JS/comp/starrating.vue"
export default component.exports